import { fetchCmtpax, readMessage } from '@/api/passenger'
const getCmtpax = (context) => {
  return fetchCmtpax().then((response) => {
    context.commit('CMTPAX_UPDATED', response)
    return response
  })
}
const updateMessage = (context, msgId) => {
  return readMessage(msgId).then((response) => {
    return response
  })
}
export default {
  getCmtpax,
  updateMessage
}
